/* eslint-disable */
import lozad from 'lozad';
export default {
  init() {
    // JavaScript to be fired on all pages
    const observer = lozad();
    observer.observe();

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(document).foundation();

    if($('#chamber-gallery').length) {
        $("#chamber-gallery").lightGallery({    
            download: false
        });
    }

    if($('#explore-gallery').length) {
        $("#explore-gallery").lightGallery({    
            download: false,
            selector: '.item'
        });
    }

    /*FullScreenSearch*/
    $('.tabs-title').click(function(){
        if($('#search_post').length) {
            $('#search_post').hide();
        }
    });

    $("#search-btn").click(function(){
        $(this).toggleClass("animate");
        var ftype = $(this).data('ftype');
        if($("#search-input").hasClass('active') && $("#search-input").val() != '') {
            if(ftype == 'post') {
                get_search_post();
            }
            if(ftype == 'business') {
                get_search_business();
            }
            
            $("#search-input").toggleClass("active").focus;
        } else {
            $("#search-input").toggleClass("active").focus;
            $("#search-input").val("");
        }
    });

    $("#search-business-grid").submit(function(e){
        e.preventDefault();
        $("#search-btn").toggleClass("animate");
        $("#search-input").toggleClass("active").focus;
        get_search_business();
    });

    function get_search_post() {
        $.blockUI();
        $('#search_post_data').html('');
        var search_data = $("#search-input").val();
        var str = '&search_data=' + search_data + '&action=search_post_ajax';
        $.ajax({
            type: "POST",
            dataType: "html",
            url: ajax_object.ajaxurl,
            data: str,
            success: function(data){
                var $data = JSON.parse(data);
                if($data['total_post'] >= '1'){
                    $('.tabs-title').removeClass('is-active');
                    $('.tabs-title a').removeAttr('aria-selected');
                    $('.tabs-panel').removeClass('is-active');
                    $('#search_post_data').html($data['result']);
                    $('#search_post').addClass('is-active').show();
                    $.unblockUI();
                } else{
                    $('.tabs-title').removeClass('is-active');
                    $('.tabs-title a').removeAttr('aria-selected');
                    $('.tabs-panel').removeClass('is-active');
                    $('#search_post_data').html('<h3>No data found</h3>');
                    $('#search_post').addClass('is-active').show();
                    $.unblockUI();
                }
            }
        });
    }


    $('#buiness-filter, #bt_select').change(function(){
        get_search_business();
    });

    function get_search_business() {
        setTimeout(function(){ 
            $('#search_business_data').html('');
            var search_data = $("#search-input").val();
            var b_filter = $('#buiness-filter').val();
            var b_type = $('#bt_select').val();
            $.blockUI();
            var str = '&search_data=' + search_data + '&b_type=' + b_type + '&b_filter=' + b_filter + '&action=search_business_ajax';
            $.ajax({
                type: "POST",
                dataType: "html",
                url: ajax_object.ajaxurl,
                data: str,
                success: function(data){
                    var $data = JSON.parse(data);
                    $('#search-input').val('');
                    if($data['total_post'] >= '1'){
                        $('#search_business_data').html($data['result']);
                        $.unblockUI();
                    } else{
                        $('#search_business_data').html('<h3>No data found</h3>');
                        $.unblockUI();
                    }
                }
            });
        }, 200);
        
    }

    $('.dropbtn').on('click', function () {
        $(this).toggleClass('expand');
        $('.dropdown-filter .dropdown-content').toggleClass('active'); //you can list several class names
    });

    /** Banner Start **/
    if($('.banner-slider').length) {
        var autoplay = $('.banner-slider').data('autoplay');
        var timeout = $('.banner-slider').data('timeout');
        $('.banner-slider').owlCarousel({
            loop:true,
            margin:0,
            nav:false,
            autoplay: autoplay,
            autoplayTimeout:timeout,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:1
                },
                1000:{
                    items:1
                }
            }
        });
        
    }
    
  },
};

$('.global-modal').addClass('active');
if($('.global-modal.active')[0]) {
  $('body').css('overflow', 'hidden');
}

$('.global-close').click(function () {
  $('.global-modal').removeClass('active');
  $('body').css('overflow', 'auto');
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js